import React from 'react'
import { Row, Col, Collapse } from 'reactstrap'
import classnames from 'classnames'
import MailchimpForm from './mailchimp-form'
import { OutboundLink } from 'gatsby-plugin-google-analytics'

class OurNews extends React.Component {

    constructor(props) {
        super(props);
            this.toggleCollapse = this.toggleCollapse.bind(this)
            this.state = {
                collapse: false
            }
        }

        toggleCollapse() {
            this.setState({ collapse: !this.state.collapse })
        }

    render() {
        return(
            <div>
                <Row>
                    <Col md="12" className="slidingPanelIntro" dangerouslySetInnerHTML={{__html:this.props.intro}} />
                </Row>
                <Row>
                <   Col md="12" className="slidingPanelLeft" dangerouslySetInnerHTML={{__html:this.props.leftCol}} />
                </Row>
            </div>
        )
    }
}

export default OurNews



// WEBPACK FOOTER //
// ./src/components/our-news.js